import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../utils/firebaseConfig";
import { addDoc, collection, serverTimestamp, doc, setDoc } from "firebase/firestore";

export default function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [guardando, setGuardando] = useState(false);
  const [errorSave, setErrorSave] = useState("");
  const resumen =
    location.state?.resumen ||
    JSON.parse(sessionStorage.getItem("resumenPedido") || "[]");

  if (!resumen || resumen.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center px-6">
        <p className="text-gray-600 text-lg">No hay resumen disponible.</p>
      </div>
    );
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-white px-6 py-12 flex flex-col items-center justify-center text-center">
      <h1 className="text-3xl md:text-4xl font-bold text-green-600 mb-4">
        ¡Gracias por hacer tu pedido!
      </h1>
      <p className="text-gray-700 text-lg mb-1">
        Recibirás una copia por correo con la cotización.
      </p>
      <p className="text-gray-500 mb-6">Si no lo ves, revisa tu carpeta de spam.</p>

      <div className="w-full max-w-md bg-gray-50 rounded-xl border p-6 text-left shadow mb-6">
        <h2 className="text-lg font-semibold text-sky-700 mb-4">Resumen del pedido:</h2>
        <ul className="divide-y divide-gray-200 text-sm">
          {resumen?.map((item) => (
            <li key={item.sku} className="py-2 flex justify-between items-start">
              <div>
                <span className="font-medium">{item.nombre}</span>
                {item.modoVenta && (
                  <span className="text-xs text-gray-500 ml-1">({item.modoVenta})</span>
                )}
              </div>
              <span className="text-gray-600">x{item.cantidad}</span>
            </li>
          ))}
        </ul>
      </div>

      <button
        type="button"
        disabled={guardando}
        onClick={async () => {
          setErrorSave("");
          try {
            const user = auth.currentUser;
            if (!user || user.isAnonymous) {
              setErrorSave("Debes iniciar sesión para guardar tu pedido.");
              return;
            }
      
            setGuardando(true);
      
            // 1) Obtén items del resumen
            const raw = Array.isArray(resumen)
              ? resumen
              : JSON.parse(sessionStorage.getItem("resumenPedido") || "[]");
            if (!raw || raw.length === 0) {
              setErrorSave("No hay productos en el resumen para guardar.");
              setGuardando(false);
              return;
            }
      
            // 2) Sanea items (sin undefined) y normaliza tipos
            const productos = raw.map((it) => {
              const precioBase =
                typeof it.precioOferta === "number"
                  ? it.precioOferta
                  : typeof it.precio === "number"
                  ? it.precio
                  : 0;
      
              const limpio = {
                sku: it.sku || "",
                nombre: it.nombre || "",
                cantidad: Number(it.cantidad || 1),
                precio: Number(precioBase),
                // estos pueden faltar: ponlos como null (NO undefined)
                modoVenta: it.modoVenta ?? null,
                imagen: it.imagen ?? null,
                categoria: it.categoria ?? null,
              };
      
              // quita cualquier key que accidentalmente quedó undefined
              return Object.fromEntries(
                Object.entries(limpio).filter(([, v]) => v !== undefined)
              );
            });
      
            // 3) Calcula total seguro
            const total = productos.reduce(
              (acc, p) => acc + (Number(p.precio) || 0) * (Number(p.cantidad) || 0),
              0
            );
      
            // 4) Construye documento con nombres que exigen tus reglas
            const docData = {
              userId: user.uid,          // string
              productos,                 // list
              total: Number(total),      // number
              estado: "pendiente",       // "pendiente" | "procesando" | "completado"
              fecha: serverTimestamp(),  // timestamp
            };
      
            // 5) Guarda en colección "pedidos"
            await addDoc(collection(db, "pedidos"), docData);
      
            // 6) Limpia y navega
            sessionStorage.removeItem("resumenPedido");
            setGuardando(false);
            navigate("/", { replace: true });
          } catch (e) {
            console.error("Error guardando pedido:", e);
            setErrorSave("Ocurrió un problema al guardar tu pedido. Intenta de nuevo.");
            setGuardando(false);
          }
        }}
        className={`px-6 py-3 rounded-lg shadow transition
          ${guardando ? "bg-gray-400 cursor-not-allowed text-white"
                      : "bg-empresarial text-white hover:bg-empresarialDark"}`}
      >
        {guardando ? "Guardando..." : "Volver al inicio"}
      </button>
    </div>
  );
}


